<main class="text-primary">
    <h1 class="display-5">Contatti</h1>
    <ul>
    <li>Per qualsiasi chiarimento inerente l'utilizzo del servizio puoi contattare l'assistenza tramite il seguente indirizzo email: <em class="text-info">supporto&#64;winowino.it</em></li><br>
    <li>Per qualsiasi aspetto inerente la proprietà del servizio contatta <em class="text-info">giorgio.restano&#64;winowino.it</em></li>
    </ul>
</main>
